module.exports = "fragment SocialSharing on SocialSharing {\n  welcomeMessage\n  shareLink\n}\n"